import React, { useEffect, useState } from 'react'
import {
  Button,
  CircularProgress,
  Container,
  FormControl,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup,
  TextField,
  Typography,
} from '@material-ui/core'
import { useHistory } from 'react-router-dom'
import { useSnackbar } from 'notistack'
import { get } from 'lodash'
import moment from 'moment'

import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos'
import searchViewStyles from './css/searchViewStyles'
import useFormHooks from '../../components/hooks/useFormHooks'
import { dateToString } from '../../assets/helperFunctions'
import RangeDateSection from '../../sections/RangeDateSection/RangeDateSection'
import { fetchData } from '../../api/api'
import { useSession } from '../../contexts/SessionContext'

const SearchView = () => {
  const classes = searchViewStyles()
  const history = useHistory()
  const { enqueueSnackbar } = useSnackbar()
  const { sessionData } = useSession()

  const [isPaymentReceipt, setIsPaymentReceipt] = useState('1')

  const handlePaymentReceiptChange = event => {
    setIsPaymentReceipt(event.target.value)
  }

  const initialTodayDate = moment()
  const initialStartDate = moment().subtract(3, 'months')

  const [initialDate, setInitialDate] = React.useState(initialStartDate)
  const [finalDate, setFinalDate] = React.useState(initialTodayDate)
  const [isLoading, setIsLoading] = useState(false)
  const [inputError, setInputError] = useState(false)

  const initialState = {
    order: '',
    dni: '',
    sku: '',
    sucursal: '',
  }

  const { handleSubmit, handleInputChange, inputs, clearInputs } = useFormHooks(
    initialState,
    async () => {
      setInputError(false)
      setIsLoading(true)
      try {
        if (get(inputs, 'paymentOrder') === '' && get(inputs, 'dni') === '') {
          setInputError(true)
          throw new Error('Completa 1 campo como mínimo')
        }

        const fetchObject = {
          sku: get(inputs, 'sku'),
          order: get(inputs, 'order'),
          dni: get(inputs, 'dni'),
          sucursal: get(inputs, 'sucursal'),
          dateStart: dateToString(initialDate),
          dateEnd: dateToString(finalDate),
          action: 'oc',
          userAuthKey: get(sessionData, 'userAuthKey'),
          view: 'serve',
          page: '0',
          size: '10',
        }

        const orderData = await fetchData({
          ...fetchObject,
        })

        const state = {
          fetchObject: {
            ...fetchObject,
          },
          orderData: { ...orderData },
        }

        history.push({
          pathname: 'resultados',
          state: JSON.stringify(state),
        })

        setIsLoading(false)
        return clearInputs()
      } catch (error) {
        enqueueSnackbar(
          get(error, 'message') || get(error, 'response.data.error_description') || '',
          {
            variant: 'error',
            autoHideDuration: 1000,
          }
        )
        setIsLoading(false)

        return error
      }
    }
  )

  useEffect(() => {
    clearInputs()
    setInitialDate(initialStartDate)
    setFinalDate(initialTodayDate)
  }, [isPaymentReceipt])

  return (
    <form className={classes.root} onSubmit={handleSubmit}>
      <Container className={classes.container}>
        <Typography variant="h5" className={classes.title}>
          Buscar producto
        </Typography>

        <FormControl component="fieldset">
          <FormLabel variant="body1" className={classes.label}>
            ¿Cliente conoce los datos de compra?
          </FormLabel>
          <RadioGroup
            aria-label="payment-receipt"
            name="payment-receipt"
            value={isPaymentReceipt}
            onChange={handlePaymentReceiptChange}
          >
            <FormControlLabel value="1" control={<Radio color="primary" />} label="Sí" />
            <FormControlLabel value="0" control={<Radio color="primary" />} label="No" />
          </RadioGroup>
        </FormControl>

        <Container className={classes.searchContainer}>
          <Typography variant="body1" className={classes.fontBold} gutterBottom>
            Datos de la boleta
          </Typography>
          {isPaymentReceipt === '1' ? (
            <>
              <Typography variant="body1" gutterBottom color="textSecondary">
                Completa 1 campo como mínimo
              </Typography>
              <TextField
                error={inputError}
                fullWidth
                label="Orden de compra"
                variant="outlined"
                name="order"
                value={get(inputs, 'order')}
                onChange={handleInputChange}
                className={classes.textField}
              />
              <TextField
                error={inputError}
                fullWidth
                label="DNI del cliente"
                variant="outlined"
                name="dni"
                value={get(inputs, 'dni')}
                onChange={handleInputChange}
                className={classes.textField}
              />
              <Typography variant="body1" className={classes.fontBold} gutterBottom>
                Datos de la boleta
              </Typography>
              <TextField
                required
                fullWidth
                label="SKU del producto"
                variant="outlined"
                name="sku"
                value={get(inputs, 'sku')}
                onChange={handleInputChange}
                className={classes.textField}
                helperText="Escanea o digita el SKU"
              />
            </>
          ) : (
            <>
              <TextField
                required
                fullWidth
                label="SKU del producto"
                variant="outlined"
                name="sku"
                value={get(inputs, 'sku')}
                onChange={handleInputChange}
                className={classes.textField}
              />
              <TextField
                fullWidth
                label="Código de sucursal (Opcional)"
                variant="outlined"
                name="sucursal"
                value={get(inputs, 'sucursal')}
                onChange={handleInputChange}
                className={classes.textField}
              />
            </>
          )}

          <Typography variant="body1" className={classes.fontBold}>
            Fecha de compra{' '}
            <Typography variant="body1" component="span" color="textSecondary">
              (Opcional)
            </Typography>
          </Typography>

          <RangeDateSection
            initialDate={initialDate}
            finalDate={finalDate}
            setInitialDate={setInitialDate}
            setFinalDate={setFinalDate}
          />
          <div className={classes.buttonContainer}>
            {isLoading ? (
              <CircularProgress />
            ) : (
              <Button
                size="large"
                variant="contained"
                color="primary"
                endIcon={<ArrowForwardIosIcon />}
                type="submit"
                style={{ height: 56 }}
              >
                {isLoading ? <CircularProgress /> : 'Buscar Producto'}
              </Button>
            )}
          </div>
        </Container>
      </Container>
    </form>
  )
}

export default SearchView
